/**
 * PredictiveSearch
 * @description Uses the Shopify predictive search api for rendering search results.
 * @link https://shopify.dev/api/ajax/reference/predictive-search
 */
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('[data-predicative-search="input"]');
    this.reset = this.querySelector('[data-predicative-search="reset"]');
    this.submitButton = this.querySelector('button[type="submit"]');

    this.predictiveSearchResults = this.querySelector('[data-predicative-search="results"]');
    this.predictiveSearchResources = this.predictiveSearchResults.getAttribute('data-resources-types') || 'product';
    this.predictiveSearchMaxSize = this.predictiveSearchResults.getAttribute('data-max-results') || 4;

    this.listeners = {
      inputChange: debounce((event) => {
        this.onChange(event);
      }, 100),
      resetClick: () => {
        this.clearInput();
        this.handleInputState();
      },
      inputKeyup: () => {
        this.handleInputState();
      },
    };

    this.handleInputState();

    this.reset.addEventListener('click', this.listeners.resetClick);
    this.input.addEventListener('input', this.listeners.inputChange);
    this.input.addEventListener('keyup', this.listeners.inputKeyup);
  }

  disconnectedCallback() {
    this.reset.removeEventListener('click', this.listeners.resetClick);
    this.input.removeEventListener('input', this.listeners.inputChange);
    this.input.removeEventListener('keyup', this.listeners.inputKeyup);
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
    this.submitButton.disabled = false;
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.predictiveSearchResources}&resources[limit]=${this.predictiveSearchMaxSize}&section_id=theme-predictive-search`)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = document.createRange().createContextualFragment(text).querySelector('#shopify-section-theme-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    trapFocus(this);
  }

  close() {
    this.predictiveSearchResults.innerHTML = '';
    this.predictiveSearchResults.style.display = 'none';
    removeTrapFocus();
  }

  handleInputState() {
    const state = this.input.value.length > 0;
    if (state) {
      this.reset.classList.remove('hidden');
    }
    else {
      this.reset.classList.add('hidden');
      this.close();
    }
    return state;
  }

  clearInput() {
    this.input.value = '';
    this.input.focus();
    this.submitButton.disabled = true;
  }
}
if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
